var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-column"},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('top'),_vm._v(" "),_c('center-tab'),_vm._v(" "),_c('bottom')],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('BackTop')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d5377d8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/product/Home.vue
// module id = null
// module chunks = 